import { render, staticRenderFns } from "./CallListing.vue?vue&type=template&id=03807964"
import script from "./CallListing.vue?vue&type=script&lang=js"
export * from "./CallListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports